import React from 'react';
import { projects } from '../../../data/projectsInfo';
import Project from '../Project/Project';

const Projects = () => {
    return (
        <div>
            <h2 className="text-6xl text-center">Projects</h2>
            <div className="w-[1140px] mx-auto">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                    {
                        projects.map((project, idx) => <Project
                            key={idx}
                            project={project}
                        ></Project>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Projects;